"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Numerical = void 0;
var react_1 = __importDefault(require("react"));
var get_1 = __importDefault(require("lodash/get"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var react_resize_detector_1 = require("react-resize-detector");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var NumberInput_1 = __importDefault(require("@CommonFrontend/NumberInput/NumberInput"));
var useSuggestedOptionsMenu_1 = require("./useSuggestedOptionsMenu");
var LightDarkThemeProvider_1 = require("Utils/LightDarkThemeProvider");
function Numerical(_a) {
    var property = _a.property, style = _a.style, onChange = _a.onChange, onSliderMouseDown = _a.onSliderMouseDown;
    var withSlider = property.withSlider, label = property.label, suffix = property.suffix, min = property.min, max = property.max, path = property.path, stepSize = property.stepSize;
    var currentValue = (0, get_1.default)(style, path);
    var theme = (0, LightDarkThemeProvider_1.useLightDarkThemeContext)().theme;
    if (withSlider) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
            react_1.default.createElement(kaleidoscope_1.SliderInput, { handleValueChange: function (value) { return onChange(value); }, theme: theme === "light" ? kaleidoscope_1.SliderTheme.Light : kaleidoscope_1.SliderTheme.Dark, label: label, unit: suffix, initialInputValue: currentValue, maximum: max, minimum: min, sliderEventHandlers: {
                    onMouseDown: onSliderMouseDown,
                } })));
    }
    var numberInputProps = {
        label: label,
        min: min,
        max: max,
        size: kaleidoscope_1.TextInputSize.Medium,
        showStepper: true,
        stepSize: stepSize,
        onChange: onChange,
    };
    if (property.suggestedOptions) {
        return react_1.default.createElement(NumberComboInput, { currentValue: currentValue, property: property, numberInputProps: numberInputProps });
    }
    return react_1.default.createElement(NumberInput_1.default, __assign({ value: currentValue }, numberInputProps));
}
exports.Numerical = Numerical;
function NumberComboInput(_a) {
    var currentValue = _a.currentValue, property = _a.property, numberInputProps = _a.numberInputProps;
    (0, tiny_invariant_1.default)(property.suggestedOptions);
    var suggestedOptions = property.suggestedOptions;
    var _b = (0, react_resize_detector_1.useResizeDetector)({ handleWidth: true, handleHeight: false }), inputWidth = _b.width, resizeDetectorRef = _b.ref;
    var _c = (0, useSuggestedOptionsMenu_1.useSuggestedOptionsMenu)({
        suggestedOptions: suggestedOptions,
        onSelect: function (value) { return numberInputProps.onChange(value); },
        width: inputWidth !== null && inputWidth !== void 0 ? inputWidth : 0,
        currentValue: currentValue,
    }), openMenu = _c.openMenu, menuComponent = _c.menuComponent, inputRef = _c.inputRef, wrapperRef = _c.wrapperRef;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", ref: resizeDetectorRef },
        react_1.default.createElement(NumberInput_1.default, __assign({ value: currentValue }, numberInputProps, { onClick: openMenu, ref: function (el) {
                inputRef(el);
                wrapperRef.current = el;
            } })),
        menuComponent));
}
